"use client";
import React, { ChangeEvent, useEffect, useState } from "react";
import { HeadModule, MainStyles } from "@/layouts/styles/ssr.style";
import AuthorCard from "@/modules/author-card";
import { definitions } from "@/services/metruyenvl";
import { useRouter, useSearchParams, ReadonlyURLSearchParams } from "next/navigation";
import authorAPI from "@/services/author_api";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import SliderShowCardAuthor from "@/modules/author-card/components/slider-show-author";
import { ResponseTypes } from "@/types/constants";
import CardBook from "@/components/card-book";
import AuthorCover from "@/modules/author-card/components/author-cover";
import { Pagination, Spin } from "antd";
import { statAPI } from "@/services/stat_api";

function AuthorBody({ slug, author }: { slug?: string; author?: any }) {
    const [listSlider, setListSlider] = useState<any[]>([]);
    const [loading, setLoading] = useState<boolean>(false);
    const [list, setList] = useState<definitions["do.BookDO"][]>([]);
    const searchParams: ReadonlyURLSearchParams = useSearchParams();
    const router = useRouter();
    const [pageSize, setPageSize] = useState<number>(15);
    const [total, setTotal] = useState<number>(0);
    const [statAuthor, setStatAuthor] = useState<definitions["do.StatsDO"]>();

    useEffect(() => {
        const getListSlider = async () => {
            try {
                const res: ResponseTypes = await authorAPI.getBooks(slug ?? "", 1, 5);
                setListSlider(res.data);
            } catch (error) {
                console.log(error);
            }
        };
        getListSlider();
    }, []);

    useEffect(() => {
        if (slug) {
            getBooks();
            getStatsData();
        }
    }, [slug, searchParams, author]);

    const getStatsData = async () => {
        try {
            const res: ResponseTypes = await statAPI.getStat("author", author.id ?? "");
            setStatAuthor(res.data);
        } catch (error) {
            console.log(error);
        }
    };

    const getBooks = async () => {
        setLoading(true);
        setPageSize(parseInt(searchParams.get("size") ?? "15"));
        try {
            const res: ResponseTypes = await authorAPI.getBooks(slug ?? "", parseInt(searchParams.get("page") ?? "1"), parseInt(searchParams.get("size") ?? "15"));
            if (res.data) {
                setList(res.data);
                setTotal(res?.paging?.total ?? 0);
            }
            setLoading(false);
        } catch (error) {
            console.log(error);
            setLoading(false);
        }
    };
    const onChangePage = (page: number, size: number) => {
        // setPage(page);
        setPageSize(size);
        router.push(`${window.location.pathname}?page=${page}&size=${size}`);
    };
    const settings: any = {
        dots: true,
        infinite: true,
        autoplay: true,
        speed: 500,
        slidesToShow: 1,
        slidesToScroll: 1,
        nextArrow: <></>,
        prevArrow: <></>,
    };

    return (
        <MainStyles>
            <div className="relative w-full bg-white rounded-2xl md:grid md:grid-flow-dense md:mt-[-120px] gap-x-10 p-6 md:p-6 " style={{ gridTemplateColumns: "1fr 0.5fr" }}>
                {/* {books?.map((item) => {
                    return <AuthorCard name={item.name} key={item.id} slug={item.slug} totalStories={10} totalReadings={20} />;
                })} */}
                <div className="w-full" style={{ gridColumn: 2 }}>
                    <AuthorCover stat={statAuthor} author={author} />
                </div>
                <div className="w-full overflow-hidden" style={{ gridColumn: 1 }}>
                    <div className="md:block hidden h-80 w-full p-5 overflow-hidden" style={{ backgroundColor: "#F7F5F0" }}>
                        <Slider {...settings}>
                            {listSlider?.map((item) => {
                                return (
                                    <div key={item.id} className="rounded-lg p-5">
                                        <SliderShowCardAuthor book={item as definitions["do.BookDO"]} />
                                    </div>
                                );
                            })}
                        </Slider>
                    </div>
                    <div className="mt-2 mb-2">
                        <HeadModule>Truyện đã đăng</HeadModule>
                        <Spin spinning={loading}>
                            {list.map((item) => {
                                return (
                                    <div key={item.id} className="md:mt-2">
                                        <CardBook book={item as definitions["do.BookDO"]} />
                                    </div>
                                );
                            })}
                        </Spin>
                    </div>
                    <Pagination total={total} current={parseInt(searchParams.get("page") ?? "1")} pageSize={parseInt(searchParams.get("size") ?? "20")} onChange={onChangePage} className="flex justify-end mb-5" />
                </div>{" "}
            </div>
        </MainStyles>
    );
}

export default AuthorBody;
